import React, { Component } from 'react';
import { Route, BrowserRouter } from "react-router-dom";
import './App.css';
import Login from './components/login';
import Home from './components/home';
import Reportes from './components/reportes';
import {ProtectedRoute} from './middleware/protected.route';
import FormularioUsuario from './components/configuracion/formularioUsuario';
import FormularioResolucion from './components/configuracion/formularioResolucion';
import Confirmacion from './components/confirmacion';
import CerrarSesion from './middleware/cerrarsesion';
import LoginClientes from './components/login_clientes';

//RUTAS GESTIONAR BUSSINE
import Empresas from './components/configuracion/empresas';
import Formularioformapago from './components/bussines/catalogos/formularios/formularioFormaPago';
import Categoriaitem from './components/bussines/catalogos/categoriaitem';
import Formulariocategoriaitem from './components/bussines/catalogos/formularios/formularioCategoriaitems';
import Formularioimpuestos from './components/bussines/catalogos/formularios/formularioImpuestos';
import Formularioretenciones from './components/bussines/catalogos/formularios/formularioRetenciones';
import Formularioservicios from './components/bussines/catalogos/formularios/formularioItemsServicios';
import Formularioclientes from './components/bussines/catalogos/formularios/formularioClientes';
import Precios from './components/bussines/catalogos/precios';
import Formulariovendedores from './components/bussines/catalogos/formularios/formularioVendedores';
import Cargaterceros from './components/archivos/cargaTerceros'
import PedidosCust from './components/bussines/pedidos/pedidosCust'
import cierreTurno from './components/reportes/cierreTurno';
import FormularioMetodoPago from './components/bussines/catalogos/formularios/formularioMetodoPago';
import ReportepedidosCust from './components/bussines/pedidos/reportepedidosCust';
import EditPedidos from './components/bussines/pedidos/Editpedidos';
import FormularioCustomer from './components/configuracion/formularioCustomer';
import ReporteEmpresas from './components/factlectronica/reporteEmpresas';
import Formulariocodigobarras from './components/bussines/catalogos/formularios/formularioCodigoBarra';
import Formularioempleados from './components/nomina/formularioEmpleado';
import EmpresasAdmin from './components/configuracion/empresaadmin';
import ReporteConsumo from './components/reportes/reporteConsumo';
import SellModulePage from './pages/sells';
import ElecDocumentPage from './pages/electronic_documents';
import PosPage from './pages/pos';
import PayrollModulePage from './pages/payroll';
import InventaryModulePage from './pages/inventary';
import CatalogModulePage from './pages/catalog';
import ConfigModulePage from './pages/configuration';
import BatchModulePage from './pages/batch';

import Pedidos from './components/bussines/pedidos/pedidos';
import Reportepedidos from './components/bussines/pedidos/reportepedidos';
import CompanyConfigModule from './components/configuracion/empresagroupmodule';
import ReporteNomina from './components/factlectronica/reporteNomina';
import ManageDocuments from './components/configuracion/manageDocuments';
import ManageDocumentsPayroll from './components/configuracion/manageDocumentsPayroll';
import AuditoriaIngresosGlobal from './components/configuracion/auditoriaIngresosGlobal';
import PortalClientesAcceso from './components/configuracion/portalClientesAcceso';

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="App-header">
          <BrowserRouter>
              <Route exact path="/" component={Login} />
              <Route exact path="/login_clientes" component={LoginClientes}/> 
              <Route exact path="/confirmacion" component={Confirmacion} /> 
              <ProtectedRoute exact path="/home" component={Home} />
              <ProtectedRoute exact path="/cerrarsesion" component={CerrarSesion} />  

              <ProtectedRoute exact path="/formularioCustomer" component={FormularioCustomer} />
              <ProtectedRoute exact path="/reportes" component={Reportes} />
              <ProtectedRoute exact path="/usuarios/crear" component={FormularioUsuario} />  
              <ProtectedRoute exact path="/resoluciones/crear" component={FormularioResolucion} />
              <ProtectedRoute exact path="/empresa" component={Empresas} />
              <ProtectedRoute exact path="/reportes" component={Reportes} />      
              <ProtectedRoute exact path="/formapago/crear" component={Formularioformapago} />
              <ProtectedRoute exact path="/categorias" component={Categoriaitem} />
              <ProtectedRoute exact path="/categorias/crear" component={Formulariocategoriaitem} />     
              <ProtectedRoute exact path="/impuestos/crear" component={Formularioimpuestos} />
              <ProtectedRoute exact path="/retenciones/crear" component={Formularioretenciones} />         
              <ProtectedRoute exact path="/listaprecio/actualizar" component={Precios} />                  
              <ProtectedRoute exact path="/servicios/crear" component={Formularioservicios} />
              <ProtectedRoute exact path="/clientes/crear" component={Formularioclientes} />  
              <ProtectedRoute exact path="/vendedores/crear" component={Formulariovendedores} />         
              <ProtectedRoute exact path="/cargaterceros" component={Cargaterceros} />      
              <ProtectedRoute exact path="/pedidosCust" component={PedidosCust} />       
              <ProtectedRoute exact path="/reportes/cierreturno" component={cierreTurno} /> 
              <ProtectedRoute exact path="/metodos/crear" component={FormularioMetodoPago} />
              <ProtectedRoute exact path="/reportepedidosCust" component={ReportepedidosCust} />
              <ProtectedRoute exact path="/editpedidos" component={EditPedidos} />
              <ProtectedRoute exact path="/reporteempresas" component={ReporteEmpresas} />
              <ProtectedRoute exact path="/reportenomina" component={ReporteNomina} />
             
              <ProtectedRoute exact path="/codigobarra/crear" component={Formulariocodigobarras} />  
              <ProtectedRoute exact path="/empleados/crear" component={Formularioempleados} />
              <ProtectedRoute exact path="/companyblock" component={EmpresasAdmin} />  
              <ProtectedRoute exact path="/reporteconsumo" component={ReporteConsumo} />  
              <ProtectedRoute exact path="/manage_doc" component={ManageDocuments} />  
              <ProtectedRoute exact path="/manage_doc_payroll" component={ManageDocumentsPayroll} />  
              <ProtectedRoute exact path="/grupoempresas" component={CompanyConfigModule} />  
              <ProtectedRoute exact path="/auditoria_ingresos" component={AuditoriaIngresosGlobal} />
              <ProtectedRoute exact path="/portal_clientes" component={PortalClientesAcceso} />

              <ProtectedRoute exact path="/pedidos" component={Pedidos} />  
              <ProtectedRoute exact path="/reportepedidos" component={Reportepedidos} />  


              <ProtectedRoute exact path="/ventas/:module?/:id?" component={SellModulePage} />  
              <ProtectedRoute exact path="/edoc/:module?/:id?" component={ElecDocumentPage} />  
              <ProtectedRoute exact path="/pos/:module?/:id?" component={PosPage} />  
              <ProtectedRoute exact path="/payroll/:module?/:id?" component={PayrollModulePage} />  
              <ProtectedRoute exact path="/inventary/:module?/:id?" component={InventaryModulePage} />  
              <ProtectedRoute exact path="/catalog/:module?/:id?" component={CatalogModulePage} />  
              <ProtectedRoute exact path="/configuration/:module?/:id?" component={ConfigModulePage} />  
              <ProtectedRoute exact path="/batch/:module?/:id?" component={BatchModulePage} />  
          </BrowserRouter>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js